import { useCallback, useState } from 'react'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

import Modal from 'components/Modal'
import IconDropdown from 'components/IconDropdown'
import ContactAddModalForm from './ContactAddModalForm/Form'
import { CorporateContactsModalActionsTypes } from 'types/corporateContacts'

const Buttons = (): JSX.Element => {
  const [modalToggle, modalToggleSet] = useState<{
    toggle: boolean
    value: CorporateContactsModalActionsTypes | null
  }>({ toggle: false, value: null })

  const OPTIONS: { label: string; value: CorporateContactsModalActionsTypes }[] = [
    { label: 'Add Contact', value: 'corporate_contacts_add' },
  ]

  const handleOnCloseModal = useCallback(() => {
    modalToggleSet({ toggle: false, value: null })
  }, [modalToggleSet])

  return (
    <>
      <div>
        <IconDropdown
          title={
            <span className="tracking-wider font-light ml-1">Add Contact</span>
          }
          icon={faPlus}
          iconClassName="text-primary"
          iconPosition="left"
          options={OPTIONS}
          toggleClassName="py-2 px-4 rounded-md text-primary border border-primary mx-1"
          itemClassName="py-1"
          menuClassName="border-gray-500 shadow-md px-2 py-3"
          displayArrowDown
          onSelect={(value) => {
            modalToggleSet({
              toggle: true,
              value: value as CorporateContactsModalActionsTypes,
            })
          }}
        />
      </div>

      <Modal
        open={modalToggle.toggle}
        title={
          OPTIONS.filter((item) => item.value === modalToggle.value)[0]?.label
        }
        onClose={handleOnCloseModal}
        noFooter
      >
        {modalToggle.value === 'corporate_contacts_add' ? (
          <ContactAddModalForm onCloseModal={handleOnCloseModal} />
        ) : null}
      </Modal>
    </>
  )
}

export default Buttons
